export const SEND_PAYMENT_LINK = 'SEND_PAYMENT_LINK';
export const CHARGE_CARD = 'CHARGE_CARD';
export const REDUCE_PAYMENT_EMAIL = 'REDUCE_PAYMENT_EMAIL';
export const REDUCE_SEND_PAYMENT_LINK_DTO = 'REDUCE_SEND_PAYMENT_LINK_DTO';
export const GET_PAYMENT_EMAIL = 'GET_PAYMENT_EMAIL';
export const REDUCE_PAYMENT_TRANSFER_RESULT_RECORDS = 'REDUCE_PAYMENT_TRANSFER_RESULT_RECORDS';
export const GET_PAYMENT_TRANSFER_RESULT_RECORDS = 'GET_PAYMENT_TRANSFER_RESULT_RECORDS';
export const CREATE_PAYMENT_TRANSFER_RESULT_RECORD = 'CREATE_PAYMENT_TRANSFER_RESULT_RECORD';
export const REDUCE_PAYMENT_TRANSFER_RESULT_READ_ONLY = 'REDUCE_PAYMENT_TRANSFER_RESULT_READ_ONLY';
export const REDUCE_PAYMENT_TRANSFER_RESULT_ERRORS = 'REDUCE_PAYMENT_TRANSFER_RESULT_ERRORS';
export const REDUCE_PAYMENT_TRANSFER_RESULT_HIDDEN = 'REDUCE_PAYMENT_TRANSFER_RESULT_HIDDEN';
